var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_a_photo_24dp_5F6368_FILL1_wght400_GRAD0_opsz24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 7V5H17V3H19V1H21V3H23V5H21V7H19ZM11 17.5C12.25 17.5 13.3125 17.0625 14.1875 16.1875C15.0625 15.3125 15.5 14.25 15.5 13C15.5 11.75 15.0625 10.6875 14.1875 9.8125C13.3125 8.9375 12.25 8.5 11 8.5C9.75 8.5 8.6875 8.9375 7.8125 9.8125C6.9375 10.6875 6.5 11.75 6.5 13C6.5 14.25 6.9375 15.3125 7.8125 16.1875C8.6875 17.0625 9.75 17.5 11 17.5ZM11 15.5C10.3 15.5 9.70833 15.2583 9.225 14.775C8.74167 14.2917 8.5 13.7 8.5 13C8.5 12.3 8.74167 11.7083 9.225 11.225C9.70833 10.7417 10.3 10.5 11 10.5C11.7 10.5 12.2917 10.7417 12.775 11.225C13.2583 11.7083 13.5 12.3 13.5 13C13.5 13.7 13.2583 14.2917 12.775 14.775C12.2917 15.2583 11.7 15.5 11 15.5ZM1 21V5H6.15L8 3H15V7H17V9H21V21H1Z",
    fill: "#756F7E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.49aa5f1e75c40ef4d3ea9ccff0ef89e9.svg";
export { ForwardRef as ReactComponent };